import clsx from 'clsx';
import type { DynamicFieldComponentProps } from '../../dynamic-form/dynamic-form.interfaces';
import FieldLabel from '../../labels/field-label';

export interface GrandScoreProps extends DynamicFieldComponentProps<string> {
  totalScore: number;
  maxPossible: number;
  percentage: string;
}

const GrandScore = ({ label, totalScore, maxPossible, percentage, labelStyles }: GrandScoreProps) => {
  const cellStyle = 'odin-table-cell odin-text-left odin-py-2 odin-px-2 odin-break-words odin-text-sm';
  const headerCellStyle = clsx(cellStyle, 'odin-border-b odin-border-gray-3 odin-font-medium');
  const dataCellStyle = clsx(cellStyle, 'odin-font-normal');

  return (
    <>
      {label && <FieldLabel label={label} labelStyles={labelStyles} />}
      <div className="odin-bg-white odin-table odin-w-full odin-border-separate">
        <div className="odin-table-header-group">
          <div className="odin-table-row">
            <div className={headerCellStyle}>Total Score</div>
            <div className={headerCellStyle}>Max Possible</div>
            <div className={headerCellStyle}>Percentage</div>
          </div>
        </div>
        <div className="odin-table-row-group">
          <div className="odin-table-row">
            <div className={dataCellStyle}>{totalScore?.toFixed(2)}</div>
            <div className={dataCellStyle}>{maxPossible?.toFixed(2)}</div>
            <div className={dataCellStyle}>{percentage}</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GrandScore;
